import type { CreateBillingCycleRequestPayload } from '@weft/api-definition';
import { useMutation } from 'react-query';
import { getPrivateApi } from '../../services/api';

export function useCreateBillingCycle() {
  return useMutation((createBillingCycleRequest: CreateBillingCycleRequestPayload) => {
    const api = getPrivateApi();

    return api.createBillingCycle({ createBillingCycleRequest });
  });
}